'use client';
import {styled} from '@mui/material/styles';
import type {ReactNode} from 'react';
import {DEFAULT_HERO_MODE, HeroMode} from './types';

// Opaque sheet that scrolls over the pinned hero; everything after the hero rides on it.
const Root = styled('div')(({theme}) => ({
  position: 'relative',
  zIndex: 1,
  background: theme.palette.colors.surface.neutral.page,
}));

export function HeroCurtain({children, mode = DEFAULT_HERO_MODE}: {children: ReactNode; mode?: HeroMode}) {
  if (mode === HeroMode.Static) {
    return <>{children}</>;
  }
  return <Root>{children}</Root>;
}

HeroCurtain.displayName = 'HeroCurtain';
